<div class="manual-pricing__popup__container">
  <div #filterViewPane class="manual-pricing__body">
    <!-- FIXING SELECTOR -->
    <div class="manual-pricing__fixing-selector__container">
      <!-- TITLE -->
      <div class="manual-pricing__fixing-selector__title">
        {{labels.fixing_rate}}
        <label
          (click)="toggleSort()"
          [ngClass]="{'btn': true, 
							  'btn-default': true, 
							  'manual-pricing__fixing-selector__sort_button': true, 
							  'icon': true,
							  'icon-ion_chevron_down': ascending,
							  'icon-ion_chevron_up': !ascending }"
          [title]="sortingTitle"
        >
        </label>
        <!-- class="btn btn-default blotter_interaction_buttons icon icon_ion_settings_filled"  -->
      </div>
      <!-- BODY - LISTING -->
      <div class="manual-pricing__fixing-selector__body">
        <div class="manual-pricing__fixing-selector__fixings-list">
          <ng-container
            *ngIf="fixingTabDataset != null && fixingTabDataset.length > 0; then fixingsListing else noRecords"
          >
          </ng-container>
        </div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="manual-pricing__content__container">
      <!-- CONTENT - TITLE -->
      <div class="manual-pricing__content__title">{{activeFixingTabData.title}}</div>
      <!-- CONTENT - BODY -->
      <div class="manual-pricing__content__body" #contentBodyContainer>
        <!-- HEADER ROW -->
        <div class="manual-pricing__header__row">
          <div class="manual-pricing__checkbox__cell manual-pricing__checkbox__header">
            <p-checkbox
              [ngClass]="{'manual-pricing__checkbox': true}"
              binary="true"
              inputId="checkboxAll"
              [(ngModel)]="activeFixingTabData.checkboxFixing.value"
              [disabled]="activeFixingTabData.checkboxFixing.locked"
              (onChange)="handleHeaderCheckboxChange()"
            >
            </p-checkbox>
          </div>
          <div class="manual-pricing__instrument__cell manual-pricing__instrument__header">
            {{labels.instrument}}
          </div>
          <div class="manual-pricing__bid__cell manual-pricing__bid__header">{{labels.bid}}</div>
          <div class="manual-pricing__mid__cell manual-pricing__mid__header">{{labels.mid}}</div>
          <div class="manual-pricing__offer__cell manual-pricing__offer__header">
            {{labels.offer}}
          </div>
          <!-- <div class="manual-pricing__scroll__cell manual-pricing__scroll__header"  *ngIf="scrollActive"></div> -->
        </div>
        <!-- CONTENT ROWs -->
        <div
          class="manual-pricing__content__row__container"
          #contentRowsContainer
          [style.height]="'100%'"
        >
          <div
            *ngFor="let fixingRateData of activeFixingTabData.rateData"
            class="manual-pricing__content__row"
            [ngClass]="{'selected': fixingRateData.checkbox.value==true && !fixingRateData.checkbox.locked, 'first': fixingRateData.first==true, 'last': fixingRateData.last}"
          >
            <div
              class="manual-pricing__checkbox__cell manual-pricing__checkbox__content manual-pricing__cell"
            >
              <p-checkbox
                [ngClass]="{'manual-pricing__checkbox': true}"
                binary="true"
                inputId="checkboxAll"
                [(ngModel)]="fixingRateData.checkbox.value"
                [disabled]="fixingRateData.checkbox.locked"
                (onChange)="handleCheckboxChange()"
              >
              </p-checkbox>
            </div>
            <div
              class="manual-pricing__cell"
              [ngClass]="{'manual-pricing__instrument__cell': true,
										 'manual-pricing__instrument__content': !fixingRateData.faded,
										 'manual-pricing__instrument__content--disabled': fixingRateData.faded}"
            >
              {{fixingRateData.instrument}}
            </div>
            <div
              class="manual-pricing__bid__cell manual-pricing__bid__content manual-pricing__cell"
            >
              <ic-price-spinner
                class="manual-pricing__spinner"
                size="sm"
                [showValidationBar]="false"
                [useBMPrecision]="true"
                [productCode]="fixingRateData.instrument"
                [inverted]="false"
                [disabled]="fixingRateData.faded"
                [(ngModel)]="fixingRateData.bid"
                (blur)="handleBidBlur(fixingRateData.id)"
                (ngModelChange)="handleSpinnerChange(fixingRateData.id)"
              >
              </ic-price-spinner>
            </div>
            <div
              class="manual-pricing__cell"
              [ngClass]="{'manual-pricing__mid__cell': true,
										 'manual-pricing__mid__content': !fixingRateData.faded,
										 'manual-pricing__mid__content--disabled': fixingRateData.faded}"
            >
              {{fixingRateData.mid}}
            </div>
            <div
              class="manual-pricing__offer__cell manual-pricing__offer__content manual-pricing__cell"
            >
              <ic-price-spinner
                #offerSpinner
                size="sm"
                class="manual-pricing__spinner"
                [showValidationBar]="false"
                [useBMPrecision]="true"
                [productCode]="fixingRateData.instrument"
                [inverted]="false"
                [disabled]="fixingRateData.faded"
                [(ngModel)]="fixingRateData.offer"
                [min]="fixingRateData.bid"
                (blur)="handleOfferBlur(fixingRateData.id)"
                (ngModelChange)="handleSpinnerChange(fixingRateData.id)"
              >
              </ic-price-spinner>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="divider"></div>
  <!-- FOOTER -->
  <div class="manual-pricing__footer bfx-footer-bar-container">
    <div
      class="manual-pricing__warning__row"
      *ngIf="activeFixingTabData.warning != null && activeFixingTabData.warning != ''"
    >
      {{activeFixingTabData.warning}}
      <label
        (click)="closeWarning()"
        class="btn btn-default manual-pricing__warning__row__close_button icon icon-close"
        title="Close warning"
      >
      </label>
    </div>
    <button
      pButton
      class="bfx-button-negative"
      [label]="labels.buttons.cancel"
      (click)="cancel()"
    ></button>
    <button
      pButton
      class="bfx-button-positive"
      [label]="labels.buttons.price"
      [disabled]="activeFixingTabData.nothingToPrice || disablePrice"
      (click)="price()"
    ></button>
  </div>
</div>

<!-- TEMPLATES  -->
<ng-template #fixingsListing>
  <div
    *ngFor="let fixingTabData of fixingTabDataset"
    class="manual-pricing__fixing-selector__fixing-tile__container"
  >
    <div
      fxLayout="row"
      [ngClass]="{'manual-pricing__fixing-selector__fixing-tile': true,
						'manual-pricing__fixing-selector__fixing-tile--selected': fixingTabData.id === activeFixingTabData.id}"
      (click)="handleTabChange(fixingTabData.id)"
    >
      <div class="manual-pricing__fixing-selector__fixing-tile__date-time">
        <div fxFlex="1 1 100%" class="manual-pricing__fixing-selector__fixing-tile__time">
          {{fixingTabData.time}}
        </div>
        <div fxFlex="1 1 100%" class="manual-pricing__fixing-selector__fixing-tile__date">
          {{fixingTabData.date}}
        </div>
      </div>
      <div class="manual-pricing__fixing-selector__fixing-tile__code" fxFlex="1 1 ">
        <span title="{{fixingTabData.codeTooltip}}"> {{fixingTabData.code}} </span>
      </div>
    </div>
    <div [ngClass]="{'manual-pricing__fixing-selector__fixing-tile__separator': true}"></div>
  </div>
</ng-template>
<ng-template #noRecords>
  <div><!-- such empty --></div>
</ng-template>
